import {useContext} from "react"
import {ChangelogContext} from "@/components/changelog/context/changelog-context"

export default function useChangelog() {
    return useContext(ChangelogContext)
}
